import(/* webpackMode: "eager" */ "/codebuild/output/src4265788598/src/apps/webapp/src/app/global-error.tsx");
